// Privacy.js
import React from 'react';
import { useNavigate } from 'react-router-dom';

const Privacy = () => {
  const navigate = useNavigate();

  return (
    <div className="about-page">
      <div className="about-content">
        <button 
          onClick={() => navigate(-1)}
          style={{
            background: 'none',
            border: 'none',
            color: 'var(--primary)',
            cursor: 'pointer',
            fontSize: '1rem',
            marginBottom: '1rem',
            padding: 0
          }}
        >
          ← Back
        </button>
        
        <h1>Privacy Policy</h1>
        
        <div className="about-section">
          <h2>Overview</h2>
          <p>
            Govstr is built with privacy as a core principle. We believe in user sovereignty 
            and minimal data collection. This policy explains how we handle your information.
          </p>
        </div>

        <div className="about-section">
          <h2>Data We Don't Collect</h2>
          <ul>
            <li><strong>Private Keys:</strong> Your private key is stored only on your device. We never transmit, store, or have access to your private key.</li>
            <li><strong>Personal Information:</strong> We don't collect names, emails, or other personal identifiers.</li>
            <li><strong>Tracking:</strong> We don't use invasive tracking cookies or fingerprinting.</li>
            <li><strong>User Profiles:</strong> Your Nostr profile data is stored on the Nostr network, not on our servers.</li>
          </ul>
        </div>

        <div className="about-section">
          <h2>Data Stored on Your Device</h2>
          <p>The following data is stored locally in your browser's storage:</p>
          <ul>
            <li><strong>Private Key:</strong> Your Nostr private key (if you choose to store it)</li>
            <li><strong>Preferences:</strong> Your country and language preferences</li>
            <li><strong>Relay List:</strong> Your configured Nostr relays</li>
            <li><strong>Saved Posts:</strong> IDs of posts you've saved</li>
            <li><strong>Profile Cache:</strong> Cached profile data for faster loading</li>
          </ul>
          <p>
            You can clear this data at any time through your browser settings or the Settings page.
          </p>
        </div>

        <div className="about-section">
          <h2>Analytics</h2>
          <p>
            We use Plausible Analytics, a privacy-focused analytics service that:
          </p>
          <ul>
            <li>Does not use cookies</li>
            <li>Does not track users across sites</li>
            <li>Does not collect personal data</li>
            <li>Is fully GDPR, CCPA, and PECR compliant</li>
          </ul>
          <p>
            We only collect aggregate, anonymous usage data to improve the app.
          </p>
        </div>

        <div className="about-section">
          <h2>Third-Party Services</h2>
          <p><strong>Nostr Relays:</strong></p>
          <p>
            Govstr connects to Nostr relays to read and publish content. Each relay may have 
            its own privacy policy. Your posts are public on the Nostr network and may be 
            stored by any relay that receives them.
          </p>
          <p><strong>External Content:</strong></p>
          <p>
            Posts may contain links to external websites. We are not responsible for the 
            privacy practices of external sites.
          </p>
        </div>

        <div className="about-section">
          <h2>Security Measures</h2>
          <ul>
            <li><strong>Content Security Policy:</strong> We implement strict CSP headers to prevent XSS attacks</li>
            <li><strong>HTTPS Only:</strong> All connections to our app are encrypted</li>
            <li><strong>Secure WebSocket:</strong> We only connect to relays using secure WebSocket (wss://)</li>
            <li><strong>Input Sanitization:</strong> All user inputs are sanitized to prevent injection attacks</li>
            <li><strong>Rate Limiting:</strong> We implement client-side rate limiting to prevent abuse</li>
          </ul>
        </div>

        <div className="about-section">
          <h2>Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access all data stored on your device through browser developer tools</li>
            <li>Delete all local data by clearing browser storage</li>
            <li>Use the app without creating an account (read-only mode)</li>
            <li>Export your private key at any time through the Account page</li>
          </ul>
        </div>

        <div className="about-section">
          <h2>Data Retention</h2>
          <p>
            We retain no user data on any server. All data is stored locally on your device 
            and persists until you clear it or uninstall the browser/app.
          </p>
        </div>

        <div className="about-section">
          <h2>Changes to This Policy</h2>
          <p>
            We may update this privacy policy from time to time. We will notify users of 
            any material changes through the app or our website.
          </p>
        </div>

        <div className="about-section">
          <h2>Contact</h2>
          <p>
            For privacy-related questions, please contact us through our official channels 
            on Nostr or at our website.
          </p>
        </div>

        <p style={{ 
          fontSize: '0.75rem', 
          color: 'var(--text-secondary)', 
          marginTop: '2rem',
          textAlign: 'center'
        }}>
          Last updated: December 2024
        </p>
      </div>
    </div>
  );
};

export default Privacy;

